/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

export const ONE_TIME_PASSWORD_REGISTRATION_PURPOSE = 'REGISTRATION';
